// ===== ENTRY POINT =====
//
// Vite bundles this module (and the SCSS) into the build. Loaded via
// <script type="module"> in index.html.

import './styles/style.scss';
import { GuestBook } from './gallery.js';

function start() {
    const weddingId =
        document.documentElement.dataset.weddingId ||
        new URLSearchParams(window.location.search).get('weddingId') ||
        1;

    window.guestBook = new GuestBook(weddingId);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
} else {
    start();
}
